import { useAtomValue } from 'jotai';
import { Navigate, Outlet } from 'react-router-dom';
import { authUserAtom } from '../../atoms/authAtoms';
import type { UserRole } from '../../types';


interface RoleGuardProps {
  allowedRoles: UserRole[];
}

export function RoleGuard({ allowedRoles }: RoleGuardProps) {
  const user = useAtomValue(authUserAtom);

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to={'/forbidden'} replace />;
  }

  return <Outlet />;
}
